import React from 'react';
import Button from '@dashboard/components/Button';
import Link from '@dashboard/components/Link';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { confirm } from '@dashboard/lib/confirm';
import { apiUrl } from '@dashboard/services/env';
import request from '@dashboard/services/request';
import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsDivider from '@dashboard/components/SettingsDivider';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import PasswordForm from './components/PasswordForm';
import NameForm from './components/NameForm';
import EmailForm from './components/EmailForm';
import ConnectedAccountsForm from './components/ConnectedAccountsForm';

const AccountProfile = () => {
  const { token, logout, user } = useAuth();
  
  const hasGoogleAccount = user?.googleId && (user?.authProvider === 'google' || user?.authProvider === 'both');
  
  async function handleDeleteAccount() {
    const result = await confirm(
      'Are you sure you want to delete your account? This will delete the complete history, including all checkouts, customers and sales',
      {
        confirm: 'Yes, delete my account',
      },
    );

    if (result) {
      const deleted = await request(`${apiUrl}/delete`, token);

      if (deleted !== true) {
        window.alert('Unable to delete your account. Please contact support.');
        return;
      }

      logout();
    }
  }

  return (
    <SettingsContainer>
      <SettingsHeader id="name">Change name</SettingsHeader>
      <NameForm />

      <SettingsDivider />

      <SettingsHeader id="email">Change email</SettingsHeader>
      <EmailForm />

      <SettingsDivider />

      <SettingsHeader id="password">Change password</SettingsHeader>
      <PasswordForm />

      <SettingsDivider />

      {hasGoogleAccount && (
        <>
          <SettingsHeader id="connected-accounts">Connected accounts</SettingsHeader>
          <ConnectedAccountsForm />

          <SettingsDivider />
        </>
      )}

      <SettingsHeader id="delete">Delete account</SettingsHeader>

      <Button handleClick={handleDeleteAccount} appearance="light">
        Delete your account
      </Button>

      <SettingsDivider />

      <div>
        <Link href="/terms">Terms of service</Link>
      </div>
    </SettingsContainer>
  );
};

export default AccountProfile;
